import Google from './Google';

export default Google;

